import routes from './routes';
import { SetRoutes } from 'components';

const UserVacanciesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default UserVacanciesPages;
